// import { Component } from '@angular/core';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { UploadService } from '../../services/upload/upload.service';
import { DmsFile } from '../../modal/upload/model/upload.model';

@Component({
  selector: 'app-drdo-aip',
  standalone: false,
  templateUrl: './drdo-aip.component.html',
  styleUrl: './drdo-aip.component.scss'
})
export class DrdoAipComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() step: any;
  @Input() id: any;
  @Input() getUrl1: any;
  @Input() postUrl1: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  @Input() postUrl: string;
  aip: FormGroup;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
aipData: any;
selectedProduct: any;
  baseUrl: string = environment.APIUrl;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  createMode: boolean = true;
  // uploadedFileName: string = '';
  file: File | null = null;
  uploadedFileName: string | null = null;
  uploadedUrl: any;
  allDmsFiles: any[] = [];
  apiUrl = environment.APIUrl;
  aipId: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  eoiData: any;
  commentForm: FormGroup;
  needGenData: any;
  @ViewChild('fileUpload') fileUpload: FileUpload;
  private subscriptions = new Subscription();
  @Output() stepCompleted = new EventEmitter<void>();
  userID: any;
  constructor(
    private messageService: MessageService,
    private fb: FormBuilder,
    private api: ApiService,
    private uploadService: UploadService,
    private route: ActivatedRoute
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
      this.commentForm = this.fb.group({
        comment: [''],
      });
      // Don't call APIs here - wait for ngAfterViewInit or ngOnChanges
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Only make API calls when component is actually displayed (when id or step changes and are valid)
    // This prevents calls when component is being destroyed or not yet ready
    if ((changes['id'] || changes['step']) && this.id && this.payload?.proposal_id) {
      // If id changed (not first change, meaning step was switched), reload data
      if (!changes['id']?.firstChange && !changes['step']?.firstChange) {
        if (changes['id']?.currentValue !== changes['id']?.previousValue) {
          this.getProposalData();
          this.getStep1();
        }
      }
      // For first change, we'll handle in ngAfterViewInit to ensure payload is set
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    // Make API calls here if component is active and payload is set
    // This ensures we only make calls when component is actually displayed in the DOM
    if (this.id && this.payload?.proposal_id && !this.eoiData) {
      this.getProposalData();
      this.getStep1();
    }
    setTimeout(() => {
      if (this.stepDetails?.can_edit ) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  getProposalData() {
    // Guard: Only make API call if component is active and has required data
    if (!this.payload?.proposal_id || !this.id) {
      return;
    }
    let stepID = sessionStorage.getItem('needStepID');
    let url;
    if (this.schemeType == 'rev') {
      url = `/revenue/need-generation/?proposal_step=${stepID}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`;
    } else {
      url = `/make1/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`;
    }
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      this.needGenData = res[0];
    });
    this.subscriptions.add(sub);
  }
  getStep1() {
    // Guard: Only make API call if component is active and has required data
    if (!this.id || !this.payload?.proposal_id) {
      return;
    }
    const sub = this.api
      .getAPI(
        `/make1/feasibility/study/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}`
      )
      .subscribe((res: any) => {
        this.eoiData = res[0];
        console.log('this is drdo AIP', this.eoiData);
        const dmsFiles: DmsFile[] = this.eoiData.dms_files;
        this.allDmsFiles = dmsFiles;
        // this.allDmsFiles = this.eoiData.dms_files;
        console.log('>>>this.eoiData', res[0]);
        this.patchFormValues(res[0]);
      });
    this.subscriptions.add(sub);
  }
  // this is use for upload document table
  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res need upload data', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });

  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    })

    // Optionally call delete API
  }
  patchFormValues(data: any): void {
    this.commentForm.patchValue({
      comment: data?.comment,
    });

    this.uploadedUrl = data?.file;
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }

  toggleCreateMode(): void {
    this.createMode = !this.createMode;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }

  // onUpload(event: any): void {
  //   const file = event.files?.[0];
  //   this.uploadedFileName = file.name;
  //   this.file = file;
  // }
  // onSubmit() {
  //   const formData = new FormData();
  //   formData.append('proposal_step', this.step.id);
  //   formData.append('comment', this.commentForm.get('comment')?.value);
  //   formData.append('file', this.file);
  //   if (this.eoiData) {
  //     const sub = this.api
  //       .putAPI(`/make1/feasibility/study/${this.eoiData.id}/`, formData)
  //       .subscribe((res: any) => {
  //         this.fileUpload.clear();
  //         this.uploadedFileName = null;
  //         this.getStep1();
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: res.message || 'Report updated successfully',
  //         });
  //       });
  //     this.subscriptions.add(sub);
  //   } else {
  //     const sub = this.api
  //       .postAPI(`/make1/feasibility/study/`, formData)
  //       .subscribe((res: any) => {
  //         this.fileUpload.clear();
  //         this.uploadedFileName = null;
  //         this.getStep1();
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: res.message || 'Report updated successfully',
  //         });
  //       });
  //     this.subscriptions.add(sub);
  //   }
  // }

  onUpload(event: any): void {
    const file = event.files?.[0];
    if (file) {
      this.uploadedFileName = file.name;
      this.file = file;
    } else {
      this.file = null;
    }
  }

  onSubmitt(): void {
    const formData = new FormData();

    formData.append('proposal_step', this.step?.id || '');
    formData.append('comment', this.commentForm.get('comment')?.value || '');

    // ✅ Only append file if it exists
    if (this.file) {
      formData.append('file', this.file);
    }

    const apiCall = this.eoiData
      ? this.api.putAPI(`/make1/feasibility/study/${this.eoiData.id}/`, formData)
      : this.api.postAPI(`/make1/feasibility/study/`, formData);

    const sub = apiCall.subscribe({
      next: (res: any) => {
        if (this.fileUpload) {
          this.fileUpload.clear();
        }
        this.uploadedFileName = null;
        this.file = null;
        this.getStep1();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Report updated successfully',
        });
      },
      error: (err: any) => {
        console.error('Upload failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Something went wrong while saving.',
        });
      },
    });
    this.subscriptions.add(sub);
  }

  onSubmit(): void {
    const formData = new FormData();
    // if (this.selectedFile) {
    //   formData.append('document', this.selectedFile);
    // }
    formData.append('proposal_step', this.id);
    // formData.append('file_name', this.aip.get('file_name')?.value);
    // formData.append('file_number', this.aip.get('file_number')?.value);

    const apiCall = this.aipId
      ? this.api.putAPI(`/revenue/aip-details/${this.aipId}/`, formData)
      : this.api.postAPI(`/revenue/aip-details/`, formData);

    const sub = apiCall.subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'File uploaded successfully',
      });

      this.aip.reset();
      // this.uploadedFiles = null;
      // this.selectedFile = null;
      this.fileUpload.clear();
      this.aipId = '';
      this.getAIPDocs();
      // Optional: reset the UI
    });

    this.subscriptions.add(sub);
  }
getAIPDocs() {
    this.aipData = [];
    const sub = this.api
      .getAPI(`/revenue/aip-details/?proposal_step=${this.id}`)
      .subscribe({
        next: (res: any) => {
          this.aipData = res;
          const defaultRow = this.aipData.find(
            (item: any) => item.file_status === 2
          );
          if (defaultRow) {
            this.selectedProduct = defaultRow;
          }
        },
        error: (err) => {},
      });
    this.subscriptions.add(sub);
  }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: 'Proposal Name', value: this.payload.proposal_name },
        { key: 'Comment', value: this.commentForm.get('comment')?.value },
      ],
    };
    this.generatePDFEmitter.emit(payload);
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }

  
//    visible: boolean = false;
//   confirmChecked=false;

//   showConfirm() {
//       if (!this.visible) {
//           this.confirmChecked = false; // Reset checkbox when opening the modal
//           this.messageService.add({ key: 'confirm', sticky: true, severity: 'info', summary: 'Are you sure you want to submit this proposal?' });
//           this.visible = true;
//       }
//   }

//     onReject() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//   }
// submitIRA() {
//   const iraPayload = {
//     proposal_step: this.id, // Using the component's id which seems to be proposal_step
//     // user: this.userID, // From your component
//     // user : parseInt(this.userID),
//     user : sessionStorage.getItem('user_id'),
//     approve_status: 1, // 1 for accept, 2 for reject
//     final_approval: this.confirmChecked ? 1 : 0, // Convert boolean to 1/0
//     remark: "", 
//     unit: sessionStorage.getItem('unit_id'),
    
//     // unit: this.challengeForm.get('coordinatingAgency')?.value || 2 // Using coordinating agency or default
//   };
//   console.log("unit id is", iraPayload.unit);
//   const sub = this.api.postAPI('/transaction/copy/proposal-ira-action/',
//     iraPayload
//   ).subscribe({
//     next: (response: any) => {
//       this.messageService.add({
//         severity: 'success',
//         summary: 'Success',
//         detail: 'IRA action submitted successfully',
//       });
//       // Emit the IRA data if needed by parent component
//       this.IRA.emit(response);
//       console.log('IRA submission response:', response);
//     },
//     error: (err) => {
//       console.error('IRA submission failed:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//         detail: 'Failed to submit IRA action',
//       });
//     }
//   });
  
//   this.subscriptions.add(sub);
// }
//   onConfirm() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.onSubmit(); 
//       console.log("hiiiii")
//       this.submitIRA();
//       this.routeConfig.emit({isRouteConfig: true, isFinalApproval: this.confirmChecked});
//   }

 
//    routeconfig() {
//       console.log('routeconfig');
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//       this.routeConfig.emit({isRouteConfig: false});
//   }


}
